import { render, staticRenderFns } from "./adjust-policy.vue?vue&type=template&id=88d87e36&scoped=true&"
import script from "./adjust-policy.vue?vue&type=script&lang=js&"
export * from "./adjust-policy.vue?vue&type=script&lang=js&"
import style0 from "./adjust-policy.vue?vue&type=style&index=0&id=88d87e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d87e36",
  null
  
)

export default component.exports